import Cookies from 'js-cookie'

const TokenKey = 'token'
const UIDKey = 'userId'
const AvatarKey = 'avatar'
const NameKey = 'name'
const FoundIdKey = 'foundId'
const PlotIdKey = 'plotId'
const PlotNameKey = 'plotName'
const ModeKey = 'mode'
const ModeKey1 = 'mode1'
const ModeKey2 = 'mode2'
const Type = 'type'
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUserId() {
  return Cookies.get(UIDKey)
}

export function setUserId(token) {
  return Cookies.set(UIDKey, token)
}

export function removeUserId() {
  return Cookies.remove(UIDKey)
}

export function getAvatar() {
  return Cookies.get(AvatarKey)
}

export function setAvatar(token) {
  return Cookies.set(AvatarKey, token)
}

export function removeAvatar() {
  return Cookies.remove(AvatarKey)
}

export function getName() {
  return Cookies.get(NameKey)
}

export function setName(token) {
  return Cookies.set(NameKey, token)
}

export function removeName() {
  return Cookies.remove(NameKey)
}

export function getFoundId() {
  return Cookies.get(FoundIdKey)
}

export function setFoundId(token) {
  return Cookies.set(FoundIdKey, token)
}

export function removeFoundId() {
  return Cookies.remove(FoundIdKey)
}

export function getPlotId() {
  return Cookies.get(PlotIdKey)
}

export function setPlotId(token) {
  return Cookies.set(PlotIdKey, token)
}

export function removePlotId() {
  return Cookies.remove(PlotIdKey)
}

export function getPlotName() {
  return Cookies.get(PlotNameKey)
}

export function setPlotName(token) {
  return Cookies.set(PlotNameKey, token)
}

export function removePlotName() {
  return Cookies.remove(PlotNameKey)
}

export function getMode() {
  return Cookies.get(ModeKey)
}

export function setMode(token) {
  return Cookies.set(ModeKey, token)
}

export function removeMode() {
  return Cookies.remove(ModeKey)
}

export function getMode1() {
  return Cookies.get(ModeKey1)
}

export function setMode1(token) {
  return Cookies.set(ModeKey1, token)
}

export function removeMode1() {
  return Cookies.remove(ModeKey1)
}

export function getMode2() {
  return Cookies.get(ModeKey2)
}

export function setMode2(token) {
  return Cookies.set(ModeKey2, token)
}

export function removeMode2() {
  return Cookies.remove(ModeKey2)
}

export function getType() {
  return Cookies.get(Type)
}

export function setType(type) {
  return Cookies.set(Type, type)
}

export function removeType() {
  return Cookies.remove(Type)
}
